/**
 * Created by florindavid on 19/12/2017.
 */
import { ReactElement, StrictMode } from 'react'
import { Provider } from 'react-redux'

import App from './App'

import store from 'lib/store'

/**
 * Connected App
 */
const ConnectedApp = (): ReactElement => {
  return (
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>
  )
}

export default ConnectedApp
